export function loadExternalScriptsFromEnv() : Promise<any[]> {
	const projectLanguageUrl = process.env.VUE_APP_PROJECT_LANGUAGE_URL;

	const promises = [];

	if (projectLanguageUrl) {
		promises.push(injectScript(projectLanguageUrl));
	}

	return Promise.all(promises);
}

export function injectScript(src: string, async: boolean = false): Promise<void> {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');

		console.log(`Injecting script ${src} (async: ${async ? 'true' : 'false'})`);

		script.type = 'text/javascript';
		script.src = src;
		script.async = async; // This makes the script load asynchronously. Change to false if you want it to be synchronous.

		script.onload = () => {
			console.log(`Script ${src} injected`);

			resolve();
		};

		script.onerror = () => {
			const errorMessage:string = `Failed to inject script ${src}`;

			console.error(errorMessage);

			reject(new Error(errorMessage));
		};

		document.head.appendChild(script);
	});
}
